/*
  Disclosure behaviour for the landing's language switcher.

  The theme ships localization-form.js for the same markup, but it assumes the
  shop layout: it stores `.header-wrapper` and calls `.menu-drawer` on open, so
  on the landing it throws before the panel ever appears. This is the same
  interaction — click to open, Escape or an outside click to close, arrows to
  move through the list — without those assumptions.
*/
if (!customElements.get('landing-locale')) {
  customElements.define(
    'landing-locale',
    class LandingLocale extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.landing-locale__button');
        this.panel = this.querySelector('.landing-locale__list');
        if (!this.button || !this.panel) return;

        this.button.addEventListener('click', this.toggle.bind(this));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
        document.addEventListener('click', this.onDocumentClick.bind(this));
      }

      get isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
      }

      toggle() {
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.panel.removeAttribute('hidden');
        this.button.setAttribute('aria-expanded', 'true');
      }

      close(refocus) {
        this.panel.setAttribute('hidden', '');
        this.button.setAttribute('aria-expanded', 'false');
        if (refocus) this.button.focus();
      }

      onDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target)) this.close();
      }

      onKeyDown(event) {
        var key = event.key;
        if (key === 'Escape' && this.isOpen) {
          event.stopPropagation();
          this.close(true);
          return;
        }
        if (key !== 'ArrowDown' && key !== 'ArrowUp') return;

        var items = Array.prototype.slice.call(this.querySelectorAll('.landing-locale__item'));
        if (!items.length) return;
        event.preventDefault();
        if (!this.isOpen) this.open();

        var index = items.indexOf(document.activeElement);
        var next = key === 'ArrowDown' ? index + 1 : index - 1;
        if (next < 0) next = items.length - 1;
        if (next >= items.length) next = 0;
        items[next].focus();
      }
    }
  );
}
